import * as React from 'react';

import PipelineSvg from '../../assets/pipeline.svg';

import styles from './onboarding-graphic-pipelines.module.css';

type Props = {
    slide: 'welcome' | 'pipeline' | 'stage' | 'automations';
};

export class OnboardingGraphicPipelines extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles[this.props.slide]}>
                <PipelineSvg />
            </div>
        );
    }
}
